import Vue from "vue";
import VueI18n from "vue-i18n";
import zhLocale from "element-ui/lib/locale/lang/zh-CN";
import enLocale from "element-ui/lib/locale/lang/en";
import frLocale from "element-ui/lib/locale/lang/fr";
import deLocale from "element-ui/lib/locale/lang/de";
import itLocale from "element-ui/lib/locale/lang/it";
import zh from "@/locales/zh-CN.json";
import en from "@/locales/en.json";
import fr from "@/locales/fr.json";
import de from "@/locales/de.json";
import it from "@/locales/it.json";

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: localStorage.getItem("lang") || "en_US",
  fallbackLocale: "en_US",
  messages: {
    zh_CN: { ...zh, ...zhLocale },
    en_US: { ...en, ...enLocale },
    fr_FR: { ...fr, ...frLocale },
    de_DE: { ...de, ...deLocale },
    it_IT: { ...it, ...itLocale }
  }
});

export default i18n;
